(function () {
  var STORAGE_KEY = 'moyshop-social-sidebar-collapsed';
  var root = document.getElementById('MoyshopSocialSidebar');
  if (!root) return;

  var toggle = root.querySelector('[data-social-toggle]');
  if (!toggle) return;

  function setCollapsed(collapsed) {
    root.classList.toggle('is-collapsed', collapsed);
    toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
    toggle.setAttribute('aria-label', collapsed ? 'Show social menu' : 'Hide social menu');
    try {
      localStorage.setItem(STORAGE_KEY, collapsed ? '1' : '0');
    } catch (e) {}
  }

  try {
    if (localStorage.getItem(STORAGE_KEY) === '1') {
      setCollapsed(true);
    }
  } catch (e) {}

  toggle.addEventListener('click', function () {
    setCollapsed(!root.classList.contains('is-collapsed'));
  });
})();
